import React from 'react';
import { connect , useSelector } from 'react-redux';
import { Container, Divider, Paper, Typography, Button, Grid } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';

import { getDrafts, getProjects, ProjectState, selectFan, updateProjectDetails, updateFanDetails, updateProjectState, resetProject } from '../../app/reducer/project.reducer';
import SearchList from '../../components/general/SearchList';
import { AuthState, getAllUsersAsync, removeUser, setSelectedUser } from '../../app/reducer/auth.reducer';
import { deleteUser } from '../../app/api/auth';



interface IRootState{
  auth: AuthState;
  history: any;
  dispatch: any;
}

export class Projects extends React.Component<IRootState, {}> {

  selectUser = (userData: any) => {
    const { dispatch } = this.props;
    
    // dispatch(updateProjectState(projectState));
    // dispatch(updateProjectDetails(projectDetails));
    // dispatch(updateFanDetails(projectDetails.fan_form));
    // if(projectDetails.fan_details){
      dispatch(setSelectedUser(userData));
    // }
    this.props.history.push('users/edit');
  }

  componentDidMount(){
    const { dispatch } = this.props;
    dispatch(getAllUsersAsync());
  }

  render() {
    const {auth, dispatch, history} = this.props;
    return (
      <div className="page-wrapper">
        <Container maxWidth="xl">
          <Paper className="form-wrapper">
            <Typography variant="h2" gutterBottom>
              <b>USERS</b>
            </Typography>
            <Divider />
           {auth.user?.userType == 1 && <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  style={{width:'100%', backgroundColor:'#10B981'}}
                  onClick={()=>{
                    dispatch(resetProject());
                    history.push('users/new');
                  }}
              >
                  <AddIcon/>&nbsp;Create New User
              </Button>
  }
            <Divider style={{paddingBottom:'20px'}}/>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <SearchList btnVariant="primary" searchLabel="Users" busy={auth.busy} colHeaders={["Name", "Email", "Role", "Status", "EDIT" ,"ACTION"]} rowKeys={["name","email","userType","isActive"]} ctaRemove={(data: any) => deleteUser(data.email)} data={auth.results} cta={(data:any)=>this.selectUser(data)}/>
              </Grid>
            </Grid>
          </Paper>
        </Container>
      </div>
    );
  }

}

const mapStateToProps = ( state: IRootState, ownProps = {} ) => ({
    auth: state.auth
});

export default connect(mapStateToProps)(Projects)